import React from 'react';
import { ListGroup } from 'react-bootstrap';
import './YearlyPercentDiff.scss';
import ComparerIndicator from '../controls/ComparerIndicator/ComparerIndicator'
import { EntityComplaint } from 'types/EntityComplaint';

type YearlyPercentDiffProps = {
    item: EntityComplaint;
    circleStyle: { backgroundColor: string; };
    index?: number;
    selectedIndexes?: boolean[];
    setSelectedIndexes?: (value: boolean[]) => void;
};

const YearlyPercentDiff: React.FC<YearlyPercentDiffProps> = ({ item, circleStyle, index, selectedIndexes, setSelectedIndexes }) => {

    const isClick = () => index != null && selectedIndexes && setSelectedIndexes;

    const handleClick = () => {
        if (isClick()) {
            selectedIndexes[index] = !selectedIndexes[index];
            setSelectedIndexes([...selectedIndexes]);
        }
    }
    const filtered = selectedIndexes && !selectedIndexes[index]
    return (
        <ListGroup.Item key={index} className="listGroup border-0 d-flex p-0" >
            <div className="col-8 d-flex align-items-center">
                <div className='d-flex col-8' onClick={isClick() ? handleClick : undefined}>
                    <div className="col-2 circle ms-2 mt-2" style={circleStyle}></div>
                    <span className={`${filtered && 'filtered'} `}>{item.description}</span>
                </div>
                <span className='col-4 d-flex justify-content-center percentNum'>{item.complaintsPercent}%</span>
            </div>
            <div className='col-4 d-flex percentNum justify-content-center'>
                <ComparerIndicator comparerData={item.comparerData} isDirectionText={true} />
            </div>
        </ListGroup.Item>
    );
};

export default YearlyPercentDiff;
